export enum FLEX_LAYOUT_ENUM {
    ROW = 'row',
    ROW_WRAP = 'row wrap',
    COLUMN = 'column',
    COLUMN_REVERSE = 'column-reverse'
}
